import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03b3c26b"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b3c26b')) {
      api.createRecord('03b3c26b', component.options)
    } else {
      api.reload('03b3c26b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03b3c26b", function () {
      api.rerender('03b3c26b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/rightBox/index.vue"
export default component.exports